export default {
  DOENCA_SOLO: 0,
  DOENCA_FOLIAR: 1,
  NEMATOIDE: 2,
  PRAGAS: 3
};
